export const cargos = [
    { id: 1, name: 'ACEITERO' },
    { id: 2, name: 'CAMARERA' },
    { id: 3, name: 'CAMPAMENTERO' },
    { id: 4, name: 'CUÑERO' },
    { id: 5, name: 'ENCUELLADOR' },
    { id: 6, name: 'MAQUINISTA' },
    { id: 7, name: 'OPERADOR MONTACARGA' },
    { id: 8, name: 'OPERADOR DE SEGURIDAD' },
    { id: 9, name: 'SOLDADOR' },
    { id: 10, name: 'OBRERO DE PATIO' },
];

export const operaciones = [
    { id: 1, name: 'OPERACION 1' },
];

export const actividades = [
    { id: 1, name: 'ACTIVIDAD 1' },
];